// extracted by mini-css-extract-plugin
export var sectionHeading = "SectionHeading-module--sectionHeading--1Ixo2";
export var wrapper = "SectionHeading-module--wrapper--Y997X";
export var fullWidth = "SectionHeading-module--fullWidth--FMe3V";
export var text = "SectionHeading-module--text--2saVp";
export var fadeIn = "SectionHeading-module--fadeIn--V-gSo";
export var slideIn = "SectionHeading-module--slideIn--30J2o";
export var bgGradient = "SectionHeading-module--bgGradient--3g7gU";
export var borderColorStep = "SectionHeading-module--borderColorStep--1ArUw";